import { render, staticRenderFns } from "./Rechazos.vue?vue&type=template&id=0d760f3b&"
import script from "./Rechazos.vue?vue&type=script&lang=js&"
export * from "./Rechazos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports